import { LitElement, css, html, svg } from "lit";
import { customElement } from "lit/decorators.js";

const icon = svg`
  <svg height="31" viewBox="0 0 34 31" width="34" xmlns="http://www.w3.org/2000/svg"><path d="m0 4.5c0-2.05078 1.64062-3.75 3.75-3.75h15c2.0508 0 3.75 1.69922 3.75 3.75v7.9102c-4.3359 1.2304-7.5 5.2148-7.5 9.9023 0 3.5156 1.6992 6.5625 4.2773 8.4375-.1757 0-.3515 0-.5273 0h-15c-2.10938 0-3.75-1.6406-3.75-3.75zm4.6875 5.625h13.125c.4687 0 .9375-.41016.9375-.9375 0-.46875-.4688-.9375-.9375-.9375h-13.125c-.52734 0-.9375.46875-.9375.9375 0 .52734.41016.9375.9375.9375zm0 3.75c-.52734 0-.9375.4688-.9375.9375 0 .5273.41016.9375.9375.9375h9.375c.4687 0 .9375-.4102.9375-.9375 0-.4687-.4688-.9375-.9375-.9375zm0 5.625c-.52734 0-.9375.4688-.9375.9375 0 .5273.41016.9375.9375.9375h5.625c.4687 0 .9375-.4102.9375-.9375 0-.4687-.4688-.9375-.9375-.9375zm12.1875 2.8125c0-4.6289 3.75-8.4375 8.4375-8.4375 4.6289 0 8.4375 3.8086 8.4375 8.4375 0 4.6875-3.8086 8.4375-8.4375 8.4375-4.6875 0-8.4375-3.75-8.4375-8.4375zm8.4375-2.8125c.7617 0 1.4063-.5859 1.4063-1.4062 0-.7618-.6446-1.4063-1.4063-1.4063-.8203 0-1.4063.6445-1.4063 1.4063 0 .8203.586 1.4062 1.4063 1.4062zm-.9375 3.75v2.8125c-.5273 0-.9375.4687-.9375.9375 0 .5273.4102.9375.9375.9375h1.875c.4688 0 .9375-.4102.9375-.9375 0-.4688-.4687-.9375-.9375-.9375v-3.75c0-.4687-.4688-.9375-.9375-.9375h-.9375c-.5273 0-.9375.4688-.9375.9375 0 .5273.4102.9375.9375.9375z" /></svg>
`;

@customElement("bp-empty-state")
export class EmptyState extends LitElement {
  static styles = css`
    :host {
      display: block;
      color: var(--color-gray);
    }

    .empty-state {
      background-color: var(--color-white);
      border-radius: var(--radius-md);
      border: 2px solid var(--color-neutral-10);
      padding: var(--size-4) var(--size-3);
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: var(--size-1-5);
      font-weight: var(--font-weight-semibold);
      text-align: center;
    }

    svg {
      max-width: var(--size-5);
      max-height: var(--size-5);
      fill: currentColor;
    }
  `;

  render() {
    return html`
      <div class="empty-state">
        ${icon}
        <slot></slot>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "bp-empty-state": EmptyState;
  }
}
